export const MAX_WIDTH = '1400px';
export const COLLAPSE_WIDTH = '1279px';
